if (!customElements.get('glossary-bar')) {
  customElements.define(
    'glossary-bar',
    class GlossaryBar extends HTMLElement {
      constructor() {
        super()
      }

      connectedCallback() {
        const letterAnchors = this.querySelectorAll('.glossary-bar--letter')
        letterAnchors.forEach((letterAnchor) => {
          const letter = letterAnchor.dataset.letter
          const anchorTarget = document.querySelector(
            `.glossary-grid__head[data-letter="${letter}"]`
          )
          if (!anchorTarget) {
            letterAnchor.setAttribute('disabled', 'disabled')
          } else {
            letterAnchor.addEventListener('click', (e) => {
              e.preventDefault()
              window.scrollTo({
                top: anchorTarget.offsetTop - 160,
                behavior: 'smooth',
              })
            })
          }
        })
      }
    }
  )
}

if (!customElements.get('section-glossary')) {
  customElements.define(
    'section-glossary',
    class Glossary extends HTMLElement {
      constructor() {
        super()
      }

      connectedCallback() {
        this.adjustSwiper()
        this.slideArrows.forEach((element) => {
          element.addEventListener('click', this.onArrowClicked.bind(this))
        })
        this.onResize();
        
        let container = this.querySelector('.glossary-grid__inner')
        let elements = Array.from(container.children)
        let sorted = elements.sort(function (a, b) {
          return +a.dataset.order - +b.dataset.order
        })
        container.innerHTML = ''
        sorted.forEach((elm) => container.append(elm))

        const broadcasts = this.querySelectorAll('.glossary-item hh-broadcast')
        broadcasts.forEach((element, index) => {
          element.addEventListener('click', () => {
            this.mainSlider.swiper.slideTo(index)
          })
          const hash = element.getAttribute('hash')
          const data = element.getAttribute('data')
          if (hash && data) {
            if (hash == window.location.hash.replace('#', '')) {
              document.dispatchEvent(
                new CustomEvent(`${hash}:open`, { detail: JSON.parse(data) })
              )
              this.mainSlider.swiper.slideTo(index)
            }
          }
        })
      }

      disconnectedCallback() {
        this.slideArrows.forEach((element) => {
          element.removeEventListener('click', this.onArrowClicked.bind(this))
        })
      }

      onResize() {
        if (this.mainSlider.swiper?.isLocked) {
          this.classList.add('locked')
        } else {
          this.classList.remove('locked')
        }
      }

      onSlideChanged() {
        this.querySelectorAll('.js-slide-arrow').forEach((element) => {
          element.removeAttribute('disabled')

          if (
            this.mainSlider.swiper.isEnd &&
            element.getAttribute('data-direction') == 'next'
          ) {
            element.setAttribute('disabled', true)
          }

          if (
            this.mainSlider.swiper.isBeginning &&
            element.getAttribute('data-direction') == 'prev'
          ) {
            element.setAttribute('disabled', true)
          }
        })
      }

      onArrowClicked(event) {
        const direction =
          event.currentTarget.getAttribute('data-direction') || 'prev'
        if (direction == 'prev') {
          this.mainSlider.swiper?.slidePrev()
        } else {
          this.mainSlider.swiper?.slideNext()
        }
      }

      adjustSwiper() {
        Object.assign(this.mainSlider, {
          allowTouchMove: false,
          on: {
            resize: () => {
              this.onResize()
            },
            transitionEnd: () => {
              this.onSlideChanged()
            }
          },
        })

        let container = this.querySelector('swiper-container')
        let elements = Array.from(container.children)
        let sorted = elements.sort(function (a, b) {
          return +a.dataset.order - +b.dataset.order
        })
        container.innerHTML = ''
        sorted.forEach((elm) => container.append(elm))

        this.mainSlider.initialize()

        
     

        const slides = document.querySelectorAll('.glossary-item__modal--slider swiper-slide');

        slides.forEach((slide) => {
          let lastY;
          slide.addEventListener('touchstart', (e) => {      
            let currentY = e.touches[0].clientY;
            lastY = currentY;
          })

          slide.addEventListener('touchmove', (e) => {
            let currentY = e.touches[0].clientY;
            let delta = currentY - lastY;
            slide.scrollTop += delta * -1;
            lastY = currentY;
          });
        })
      
      // get movement and scroll the same way
      
      }

      get mainSlider() {
        return this.querySelector('.js-media-slider')
      }

      get slideArrows() {
        return this.querySelectorAll('.js-slide-arrow')
      }
    }
  )
}
